import {TabCommunicationBroadcastChannel} from './TabCommunicationBroadcastChannel.ts'
import {TabCommunicationLocalStorage} from './TabCommunicationLocalStorage.ts'

export enum TabCommunicationEvent {
    ReloadWebsite,
}

export interface TabCommunicationInterface {
    sendEvent(event: TabCommunicationEvent): void
    onEvent(event: TabCommunicationEvent, callback: () => void): void
}

export class TabCommunication {
    static createTabCommunication(): TabCommunicationInterface {
        if(TabCommunicationBroadcastChannel.isAvailable()) return new TabCommunicationBroadcastChannel()
        return new TabCommunicationLocalStorage()
    }
}
